"use client";

import Link from "next/link";
import { usePathname } from "next/navigation";
import { LEGAL_LINKS } from "@/content/legal/links";

const LegalPolicyTabs = () => {
  const pathname = usePathname();

  return (
    <nav aria-label="Policies" className="rounded-[16px] bg-[#f3f4f6] p-1.5">
      {LEGAL_LINKS.map(({ href, label }) => {
        const isActive = pathname === href;
        return (
          <Link
            key={href}
            href={href}
            aria-current={isActive ? "page" : undefined}
            className={`block whitespace-nowrap rounded-[10px] px-3 py-2 text-[13px] leading-5 transition-colors ${
              isActive
                ? "bg-white font-medium text-[#111111] shadow-[0_1px_2px_rgba(16,24,40,0.08),0_2px_6px_rgba(16,24,40,0.06)]"
                : "font-normal text-[#71717a] hover:bg-white/70 hover:text-[#202020]"
            }`}
          >
            {label}
          </Link>
        );
      })}
    </nav>
  );
};

export default LegalPolicyTabs;
